import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('TAG_MODERATIONS_CATEGORIES_MODE_VIDEO').plugin(axiosPlugin, {template: "array"});
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchCategoriesModeVideo = (query) => fetchAction(`/tag-moderations/categories-video?${queryString.stringify(query)}`);
export const resetCategoriesModeVideo = () => redux.actions.reset();

export const categoriesModeVideo = redux.reducer();